import { Component, OnDestroy, OnInit } from '@angular/core';
import { GestorContenidoService } from '../services/gestor-contenido.service';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { environment } from '../../environments/environment';
import { Subscription } from 'rxjs';
import { CookieConsentService } from '../shared/cookie-consent/cookie-consent.service';

@Component({
    selector: 'app-blog',
    templateUrl: './blog.component.html',
    styles: [],
    standalone: false
})
export class BlogComponent implements OnInit, OnDestroy {
  listaNoticias: any[] = [];
  listaArticulos: any[] = [];
  listaVideos: any[] = [];
  listaProductos: any[] = [];
  cantidadMostrar: number = 4;
  youtubeConsent = false;
  private consentSub: Subscription | null = null;


  constructor(private _gestorContenido: GestorContenidoService,
    private sanitizer: DomSanitizer,
    private readonly cookieConsent: CookieConsentService) {
      window.scroll(0, 0);
  }

  ngOnInit(): void {
    this.consentSub = this.cookieConsent.state$.subscribe(() => {
      this.youtubeConsent = this.cookieConsent.isProviderAccepted('youtube');
    });
    this.getNoticiasPrincipales();
    this.getArticulosPrincipales();
    this.getVideosPrincipales();
    this.getProductosPrincipales();
  }

  ngOnDestroy(): void {
    this.consentSub?.unsubscribe();
  }

  getNoticiasPrincipales() {
    const pagina = 0;
    this._gestorContenido.getNoticiasPrincipales(pagina).subscribe(
      (response: any) => {
        const page = response;
        this.listaNoticias = page.rows.slice(0, this.cantidadMostrar);
      },
      (error) => {

      }
    );
  }

  getArticulosPrincipales() {
    const pagina = 0;
    this._gestorContenido.getArticulosPrincipales(pagina).subscribe(
      (response: any) => {
        const page = response;
        this.listaArticulos = page.rows.slice(0, this.cantidadMostrar);
      },
      (error) => {

      }
    );
  }

  getVideosPrincipales() {
    const pagina = 0;
    this._gestorContenido.getVideosPrincipales(pagina).subscribe(
      (response: any) => {
        const page = response;
        this.listaVideos = page.rows.slice(0, this.cantidadMostrar);
      },
      (error) => {

      }
    );
  }

  getProductosPrincipales() {
    const pagina = 0;
    this._gestorContenido.getProductosPrincipales(pagina).subscribe(
      (response: any) => {
        const page = response;
        this.listaProductos = page.rows.slice(0, this.cantidadMostrar);
      },
      (error) => {

      }
    );
  }

  /** Solo se confía en URLs HTTPS de dominios permitidos (environment.allowedIframeHosts, lista separada por coma) para evitar XSS. */
  sanitizeUrl(url: string): SafeResourceUrl {
    const raw = environment.allowedIframeHosts ?? '';
    const defaultList = 'www.youtube.com,youtube.com,www.youtube-nocookie.com,youtube-nocookie.com,youtu.be';
    const allowedHosts = (raw.includes('__') ? defaultList : raw)
      .split(',')
      .map(s => s.trim())
      .filter(Boolean);
    try {
      const parsed = new URL(url);
      const isHttps = parsed.protocol === 'https:';
      const isAllowedHost = allowedHosts.some(h => parsed.hostname === h || parsed.hostname.endsWith('.' + h));
      if (isHttps && isAllowedHost) {
        // Safe: url validada (HTTPS + host en allowedIframeHosts); evita XSS
        return this.sanitizer.bypassSecurityTrustResourceUrl(url); // NOSONAR
      }
    } catch {
      // URL inválida
    }
    return this.sanitizer.bypassSecurityTrustResourceUrl('about:blank'); // NOSONAR - URL literal segura
  }

  transformarTitulo(titulo: string){
    return titulo.replace(/ /g, '_');
  }
}
